import { render, staticRenderFns } from "./kakuzais_confirm_table.vue?vue&type=template&id=4af8ec4e&lang=pug&"
import script from "./kakuzais_confirm_table.vue?vue&type=script&lang=js&"
export * from "./kakuzais_confirm_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports